export default __webpack_public_path__ + "static/media/mm.2b4171f4.png";